import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useMemo } from 'react'
import { APP_PLATFORM, APP_STORE_URL, CHECKOUT_API_BASE_URL, IS_REVIEW_DISMISSABLE, REVIEW_BASE_URL, REVIEW_INTERVAL_IN_MIN, STICKY_REVIEW_INTERVAL_IN_MIN, UNLEASH_ENABLE_REVIEW_COLLECTOR } from './config';
import { ReviewProvider } from '@reconvert/review-collector-ui';
import { useAppSelector } from './app/hooks';
import { RootState } from './app/store';
import { useFetch } from './hooks/useFetch';
import { selectAppState } from './app/slice/appSlice';
import { StoreInfo } from './app/slice/appSlice.model';
import { Platform } from './models';
import { useFlag } from '@unleash/proxy-client-react';
import { isOlderThan24Hours } from './utils/helpers';

export const selectShopInfoState = (state: RootState) => state.shopinfo;

function ReviewProviderWrapper({ children, app, shopify, token }: { children: React.ReactNode, app: any, shopify: any, token: any }) {
  const { platformStoreId, storeInfo: storeInfo = {} as StoreInfo, loading } = useAppSelector(selectAppState);
  const { shopInfo: shopInfoFromSlice } = useAppSelector(selectShopInfoState);

  const authenticatedFetch = useFetch(app, shopify, token);
  const isReviewCollectorEnable = useFlag(UNLEASH_ENABLE_REVIEW_COLLECTOR);

  const isReviewCollectorDisabled = useMemo(() => {
    if (shopInfoFromSlice?.install_date) {
      return !(isReviewCollectorEnable && isOlderThan24Hours(shopInfoFromSlice?.install_date));
    }
  }, [isReviewCollectorEnable, shopInfoFromSlice?.install_date, isOlderThan24Hours]);


  if (APP_PLATFORM !== Platform.Shopify) {
    return <>{children}</>;
  }

  if (loading) {
    return <>{children}</>;
  }

  return (
    <ReviewProvider
      reviewBaseUrl={REVIEW_BASE_URL || ''}
      fetch={authenticatedFetch}
      platformStoreId={platformStoreId || ''}
      storeId={String(storeInfo?.storeClientId || '')}
      appStoreUrl={APP_STORE_URL || ''}
      storeUrl={storeInfo?.storeUrl || ''}
      reviewIntervalInMinutes={Number(REVIEW_INTERVAL_IN_MIN) || 0}
      sendSegmentEvents={true}
      segmentBaseUrl={CHECKOUT_API_BASE_URL || ''}
      reviewLocations={{
        FLOW_BUILDER: {
          widgetLocation: 'FLOW_BUILDER',
          locationForEvent: 'Flow builder',
        },
        MODAL_WIDGET_V2: {
          widgetLocation: 'FLOW_BUILDER_HELP_MODAL',
          locationForEvent: 'Flow builder help',
        },
      }}
      disableReview={isReviewCollectorDisabled}
      isDismissableReview={IS_REVIEW_DISMISSABLE}
      stickyReviewIntervalInMinutes={Number(STICKY_REVIEW_INTERVAL_IN_MIN) || 0}
    >
      {children}
    </ReviewProvider>
  )
}

export default ReviewProviderWrapper